import React, { Component } from 'react'
import { connect } from 'react-redux'
import s from './CurrentEarningsChart.css'
import i18n from '../../../i18n.js'
import ReactEcharts from 'echarts-for-react'
import { getEarningsChart } from '../charts.js'



class CurrentEarningsChart extends Component {
  render() {
    const { earningsAggs, earningsType, type } = this.props
    let earningsAggsFiltered = []

    if (earningsType === 'growth-all') {
      earningsAggsFiltered = earningsAggs.filter(x => x.tierOne === 'All')
    }
    if (earningsType === 'growth-rpt') {
      earningsAggsFiltered = earningsAggs.filter(x => x.tierOne === 'Reported')
    }
    if (earningsType === 'surprise') {
      earningsAggsFiltered = earningsAggs.filter(x => x.tierOne === 'Reported')
    }

    let displayStartDate = earningsAggsFiltered[0].periodStartD
    let displayEndDate = earningsAggsFiltered[0].periodEndD
    let displayRange = earningsAggsFiltered[0].displayRange
    if (earningsAggsFiltered) {
      const salesGrowth = earningsAggsFiltered.filter(x => x.salesBlendedGrowth != null)
      const earningsGrowth = earningsAggsFiltered.filter(x => x.epsBlendedGrowth != null)
      const earSurprise = earningsAggsFiltered.filter(x => x.epsSurprise != null)
      const salesSurprise = earningsAggsFiltered.filter(x => x.salesSurprise != null)

      let showSalesGrowth = true
      let showEarningsGrowth = true
      let showEarSurprise = true
      let showSalesSurprise = true

      if (type === 'salesGrowth' && salesGrowth.length === 0) {
        showSalesGrowth = false
      } else if (type === 'earningsGrowth' && earningsGrowth.length === 0) {
        showEarningsGrowth = false
      } else if (type === 'surprise' && earSurprise.length === 0) {
        showEarSurprise = false
      } else if (type === 'surprise' && salesSurprise.length === 0) {
        showSalesSurprise = false
      }

      return (
        <div className='earnings-details'>
          {earningsAggsFiltered.length > 0 && type === 'salesGrowth' && showSalesGrowth === true && (
            <div className={s.chartHeader}>
              <div className='row' style={{ marginBottom: '5px' }}></div>
              <div className='heading' style={{ color: '#050139', fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>
                {i18n.t('Sales-Growth')}{' '}
              </div>
              <div className={s.chartContainer}>
                <ReactEcharts option={getEarningsChart(earningsAggsFiltered, type)} theme='default' style={{ height: 400 }} />
              </div>
            </div>
          )}

          {earningsAggsFiltered.length > 0 && type === 'earningsGrowth' && showEarningsGrowth === true && (
            <div className={s.chartHeader}>
              <div className='row' style={{ marginBottom: '5px' }}></div>
              <div className='heading' style={{ color: '#050139', fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>
                {i18n.t('Earnings-Growth')}{' '}
              </div>
              <div className={s.chartContainer}>
                <ReactEcharts option={getEarningsChart(earningsAggsFiltered, type)} theme='default' style={{ height: 400 }} />
              </div>
            </div>
          )}
          {earningsAggsFiltered.length > 0 && type === 'salesSurprise' && showSalesSurprise === true && (
            <div className={s.chartHeader}>
              <div className='row' style={{ marginBottom: '5px' }}></div>
              <div className='heading' style={{ color: '#050139', fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>
                {i18n.t('Sales-Surprise')}{' '}
              </div>
              <div className={s.chartContainer}>
                <ReactEcharts option={getEarningsChart(earningsAggsFiltered, type)} theme='default' style={{ height: 400 }} />
              </div>
            </div>
          )}

          {earningsAggsFiltered.length > 0 && type === 'earningsSurprise' && showEarSurprise === true && (
            <div className={s.chartHeader}>
              <div className='row' style={{ marginBottom: '5px' }}></div>
              <div className='heading' style={{ color: '#050139', fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>
                {i18n.t('Earnings-Surprise')}{' '}
              </div>
              <div className={s.chartContainer}>
                <ReactEcharts option={getEarningsChart(earningsAggsFiltered, type)} theme='default' style={{ height: 400 }} />
              </div>
            </div>
          )}

          <div className={'introCopy'}>
            <span style={{ textAlign: 'left', color: '#050139', fontSize: '10px', fontWeight: '400', marginTop: '5px', marginBottom: '5px' }}>
              {i18n.t('source')} {displayRange} refers to companies with financial report periods between these dates {displayStartDate} - {displayEndDate}{' '}
            </span>
          </div>
        </div>
      )
    } else return null
  }
}

function mapStateToProps(state) {
  return {
    earningsConstituents: state.data.earningsConstituents,
    earningsAggs: state.data.earningsAggs,
    earningsAggsAll: state.data.earningsAggsAll,
    data: state.data,
    earningsType: state.data.earningsType
  }
}
export default connect(mapStateToProps, {})(CurrentEarningsChart)



// WEBPACK FOOTER //
// ./src/components/App/CurrentDetailsTable/CurrentEarningsChart.js